import { idb } from "../db/index.ts";
import { g } from "../util/index.ts";
import type { UpdateEvents, ViewInput } from "../../common/types.ts";
import { isSport } from "../../common/sportFunctions.ts";
import { getAiPayrollBudget } from "../core/team/aiFinances.baseball.ts";

const updateLeagueFinances = async (
	inputs: ViewInput<"leagueFinances">,
	updateEvents: UpdateEvents,
	state: any,
) => {
	if (
		updateEvents.includes("firstRun") ||
		(inputs.season === g.get("season") &&
			(updateEvents.includes("gameSim") ||
				updateEvents.includes("newPhase"))) ||
		state.season !== inputs.season
	) {
		const players = await idb.cache.players.indexGetAll("playersByTid", [
			0,
			Infinity,
		]);

		const teams = (
			await idb.getCopies.teamsPlus(
				{
					attrs: ["tid", "budget", "strategy"],
					seasonAttrs: [
						"att",
						"revenue",
						"profit",
						"cash",
						"payrollOrSalaryPaid",
						"pop",
						"abbrev",
						"tid",
						"region",
						"name",
						"imgURL",
						"imgURLSmall",
						"expenseLevels",
					],
					season: inputs.season,
				},
				"noCopyCache",
			)
		).map((t) => {
			const rosterSpots =
				g.get("maxRosterSize") - players.filter((p) => p.tid === t.tid).length;

			return {
				...t,
				rosterSpots,
			};
		});
		// Baseball: the payroll budget the AI plans signings and call-ups with (only exists for the current season, and
		// never for the user's team)
		const aiBudgets =
			isSport("baseball") && inputs.season === g.get("season")
				? Object.fromEntries(
						await Promise.all(
							teams.map(async (t) => [t.tid, await getAiPayrollBudget(t.tid)] as const),
						),
					)
				: undefined;
		return {
			aiBudgets,
			season: inputs.season,
			teams,
		};
	}
};

export default updateLeagueFinances;
